import React, { useState } from "react"
import { Image } from "react-bootstrap"

import playBtn from "../../images/VideoPlayButton.svg"
import { PlayButtonContainer } from "../../styles/Components/VideoTestimonial/VideoSlideStyles"
import Img from "../../utils/OptimizedImage"
import VideoModal from "../Modal/VideoModal/VideoModal"

const ImageVideo = ({ mediaType, image, video }) => {
  const [play, setPlay] = useState(false)
  if (mediaType === "image") {
    return image?.gatsbyImageData ? (
      <Img
        className="thumbnail-img"
        image={image?.gatsbyImageData}
        alt={image?.alt || image?.title}
      />
    ) : (
      image?.url && (
        <Img
          className="thumbnail-img"
          image={image?.url}
          alt={image?.alt || image?.title}
        />
      )
    )
  }

  return (
    <>
      <Image
        alt="Play"
        className="thumbnail-img"
        onClick={() => setPlay(true)}
        src={video?.thumbnail?.url}
      />
      <PlayButtonContainer onClick={() => setPlay(true)}>
        <Img className="img-play-btn" src={playBtn} alt="play video" />
      </PlayButtonContainer>
      {typeof window !== "undefined" && video && (
        <VideoModal play={play} setPlay={setPlay} component={video} />
      )}
    </>
  )
}

export default ImageVideo
